// src/config.ts
interface AppConfig {
  apiHost: string;
  apiBaseUrl: string;
  thumbnailsPerPage: number;
  gridInterval: number;
}

// This variable will hold the loaded configuration.
let appConfig: AppConfig;

/**
 * Fetches and stores the application configuration from /config.json.
 * This function is called once when the application starts.
 * @returns A promise that resolves when the configuration is loaded.
 */
export const loadAppConfig = async (): Promise<void> => {
  try {
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error('config.json not found or is invalid');
    }
    appConfig = await response.json();
  } catch (error) {
    console.error('Error loading application configuration:', error);
    // As a fallback, use a default production URL if config loading fails.
    appConfig = {
      apiHost: 'https://muu-e9991c8895.heteml.net',
      apiBaseUrl: 'https://muu-e9991c8895.heteml.net/room_image',
      thumbnailsPerPage: 12, // Default value
      gridInterval: 4,
    };
  }
};

/**
 * Returns the loaded application configuration.
 * Throws an error if the configuration has not been loaded yet.
 * @returns The application configuration object.
 */
export const getConfig = (): AppConfig => {
  if (!appConfig) {
    throw new Error('Configuration has not been loaded. Call loadAppConfig() first.');
  }
  return appConfig;
};
